import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/layout/SiteLayout';
import { Home } from './pages/Home';
import { Events } from './pages/Events';
import { About } from './pages/About';
import { Photos } from './pages/Photos';
import { LocalChurches } from './pages/LocalChurches';
import { Connect } from './pages/Connect';
import { Give } from './pages/Give';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmlt91jqfz37">
      <Routes data-id="element-1" data-mp="2mn5bkjdaophr">
        <Route element={<SiteLayout data-id="element-3" data-mp="2mjpwvhnj9igv" />} data-id="element-2" data-mp="2mndna7xolord">
          <Route path="/" element={<Home data-id="element-5" data-mp="31ayq00qn9lyr" />} data-id="element-4" data-mp="31agnimde2bie" />
          <Route path="/events" element={<Events data-id="element-7" data-mp="31cjn9y4cfj0b" />} data-id="element-6" data-mp="31c9vc4zqn1rz" />
          <Route path="/about" element={<About data-id="element-9" data-mp="2wiyvintcfl9k" />} data-id="element-8" data-mp="2wka0gqyiyz29" />
          <Route path="/photos" element={<Photos data-id="element-11" data-mp="28ufp6dtutik4" />} data-id="element-10" data-mp="2wip6b2g4hi4x" />
          <Route path="/local-churches" element={<LocalChurches data-id="element-13" data-mp="28suvsrja05nu" />} data-id="element-12" data-mp="28tw44o8wqe1v" />
          <Route path="/connect" element={<Connect data-id="element-15" data-mp="23vulg4fe8gqx" />} data-id="element-14" data-mp="28s2z1ddy01vz" />
          <Route path="/give" element={<Give data-id="element-17" data-mp="23t8fuac2cbbc" />} data-id="element-16" data-mp="23ujlygszdv5m" />
          {/* Legacy WordPress route */}
          <Route path="/contact-us" element={<Navigate to="/connect" replace data-id="element-19" data-mp="3ihv2ugmu8pjx" />} data-id="element-18" data-mp="3iiwaeb4natww" />
          <Route path="*" element={<NotFound data-id="element-21" data-mp="3mk84otygs3bf" />} data-id="element-20" data-mp="3mkre1ma1tjdu" />
        </Route>
      </Routes>
    </BrowserRouter>;
}